module.exports = __webpack_public_path__ + "static/media/Jason_S.e0bf1bee.jpg";